<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="icon-bar">
          <!--
          <a href="#"><img src="~@/assets/story/images/undo.png" /></a>
          <a href="#"><img src="~@/assets/story/images/redo.png" /></a>
          <a href="#"><img src="~@/assets/story/images/Group-1092x_1Group 109@2x.png"/></a>

          <a @click="toggleMenu()"
            ><img src="~@/assets/story/images/Filter_1Filter.png"
          /></a>-->
        </div>
      </div>
      <div class="col text-right">
        <div class="viewAs d-inline">
          <button class="btn" v-if="isInGridView" v-on:click="setViewAs(false)">
            <i
              class="fa fa-bars"
              data-toggle="tooltip"
              data-placement="top"
              title="View As List"
            ></i>
          </button>
          <button class="btn" v-else v-on:click="setViewAs(true)">
            <i
              class="fa fa-th-large"
              data-toggle="tooltip"
              data-placement="top"
              title="View As Grid"
            ></i>
          </button>
          <!-- <a href="#"><i class="fa fa-search"></i></a> -->
          <!-- <a href="#">View As
              <b-dropdown
                id="dropdown"
                dropdown
                text=""
                variant="light"
                style="margin-top: -5px"
              >
                <b-dropdown-item v-on:click="setViewAs('grid')"
                >Grid View
                </b-dropdown-item
                >
                <b-dropdown-item v-on:click="setViewAs('list')"
                >List View
                </b-dropdown-item
                >
              </b-dropdown>
          </a> -->
        </div>
        <div class="d-inline">
          <div class="btn-group">
            <button
              type="button"
              class="filter-btn p-3"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="ml-3 font-weight-bold"> Sort By</span>
              <i class="fas fa-arrow-down ml-3"></i
                 >
            </button>
            <div class="dropdown-menu">
              <div class="dropdown-item d-flex justify-content-between"
                >
                <div class="w-75">
                    Title 
                </div>
                <div class="up-down-btn text-center">
                    <i class="fas fa-arrow-down" v-on:click="setSortOrder('t-d')"></i>
                    <i class="fas fa-arrow-up" v-on:click="setSortOrder('t-a')"></i
                >
                </div>
              </div>
              <div class="dropdown-item d-flex justify-content-between"
                >
                <div class="w-75">
                    Date
                </div>
                <div class="up-down-btn text-center">
                    <i class="fas fa-arrow-down" v-on:click="setSortOrder('d-d')"></i>
                    <i class="fas fa-arrow-up" v-on:click="setSortOrder('d-a')"></i
                >
                </div>
              </div>
              <div class="dropdown-item d-flex justify-content-between"
                >
                <div class="w-75">
                    Author
                </div>
                <div class="up-down-btn text-center">
                    <i class="fas fa-arrow-down" v-on:click="setSortOrder('a-d')"></i>
                    <i class="fas fa-arrow-up" v-on:click="setSortOrder('a-a')"></i
                >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs text-center my-2">
      <div class="navbar p-0" id="navbar">
        <div class="dropup">
          <button class="dropbtn">
            <a class="active dropbtn" href="#"
              ><img
                src="~@/assets/story/images/noun_organization_201598.png"
                alt="Logo"
                class="logo-img"
              />Organization</a
            >
          </button>
          <div class="dropup-content">
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="glyphicon glyphicon-user"></i
              ></span>
              <input
                id="search"
                type="text"
                class="form-control"
                name="search"
                placeholder="Search"
                v-on:keyup="searchOrganizations"
                v-model="searchOrganizationsName"
              />
            </div>

            <div class="radioGroup">
              <div class="form-check">
                <input
                  @change="organizationFilter('All')"
                  class="form-check-input"
                  type="checkbox"
                  v-model="allOrganizationSelect"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Select All
                </label>
              </div>

              <template v-for="item in organizationList">
                <div class="form-check">
                  <input
                    @change="organizationFilter(item)"
                    class="form-check-input"
                    type="checkbox"
                    name="flexRadioDefault"
                    v-model="item.checked"
                  />
                  <label class="form-check-label" for="flexRadioDefault1">
                    {{ item.name }}
                  </label>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="dropup">
          <button class="dropbtn">
            <a href="#"
              ><img
                src="~@/assets/story/images/noun_User_3680417.png"
                alt="Logo"
                class="logo-img"
              />
              Author</a
            >
          </button>
          <div class="dropup-content">
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="glyphicon glyphicon-user"></i
              ></span>
              <input
                id="email"
                type="text"
                class="form-control"
                name="search"
                placeholder="Search"
                v-model="searchAuthorName"
                v-on:keyup="searchAuthors"
              />
            </div>

            <div class="radioGroup">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                  v-model="selectAllAuthors"
                  @change="update('All')"
                />
                <label
                  class="form-check-label"
                  for="flexCheckDefault"
                  v-on:click="update('All')"
                >
                  Select All
                </label>
              </div>

              <div
                class="form-check"
                v-for="user in finalAuthors"
                :key="user.name"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="author"
                  :id="user.name"
                  v-model="user.checked"
                  @change="update(user)"
                />
                <label class="form-check-label" for="Amir">
                  {{ user.name }}
                </label>
              </div>

              <!-- <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              value="Anas"
              name="author"
              v-model="filterAuthor"
              v-on:click="update"
            />
            <label class="form-check-label" for="Anas">
              Anas
            </label>
          </div>


           <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              value="Custom"
              name="author"
              v-model="filterAuthor"
              v-on:click="update"
              v-b-modal.modal-1
            />
            <label class="form-check-label" for="flexRadioDefault1" v-b-modal.modal-1>
              Custom
            </label>
          </div> -->
            </div>
          </div>
        </div>

        <div class="dropup">
          <button class="dropbtn">
            <a href="#"
              ><img
                src="~@/assets/story/images/noun_date_2080390.svg"
                alt="Logo"
                class="logo-img"
              />Creation Date</a
            >
          </button>
          <div class="dropup-content">
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="glyphicon glyphicon-user"></i
              ></span>
              <input
                id="email"
                type="text"
                class="form-control"
                name="searchDate"
                placeholder="Search"
                v-model="searchDateName"
                v-on:keyup="searchDates"
              />
            </div>
            <div class="radioGroup">
              <div
                class="form-check"
                v-for="date in finalCreationDates"
                :key="date.name"
              >
                <input
                  type="radio"
                  :value="date.name"
                  placeholder="Search"
                  name="searchByDate"
                  v-model="searchByDate"
                  v-on:change="creationDate"
                />
                <label class="form-check-label" for="Date">
                  {{ date.name }}
                </label>
              </div>
              <div class="form-check">
                <label
                  style="background-color: gray; width: 100px; color: #fff"
                >
                  Custom
                </label>

                <div class="form-group">
                  <label for="fromDate" style="background-color: #cecece"
                    >From date:</label
                  >

                  <input
                    type="date"
                    id="start"
                    name="trip-start"
                    v-model="fromDate"
                    :max="toDate"
                    v-on:change="creationDateByCustom"
                  />

                  <label for="toDate" style="background-color: #cecece"
                    >To date:</label
                  >

                  <input
                    type="date"
                    id="start"
                    name="trip-start"
                    v-model="toDate"
                    :min="fromDate"
                    v-on:change="creationDateByCustom"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="radioGroup">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Any"
                   name="searchByDate"
                  placeholder="Search"
                  v-model="searchByDate"
                  ref="precheck"
                  v-on:change="creationDate"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Any
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Last 30 Days"
                  placeholder="Search"
                  name="searchByDate"
                  v-model="searchByDate"
                  v-on:change="creationDate"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Last 30 Days
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Last 3 Months"
                  placeholder="Search"
                  name="searchByDate"
                  v-model="searchByDate"
                  v-on:change="creationDate"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Last 3 Months
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value="Last Year"
                  placeholder="Search"
                  name="searchByDate"
                  v-model="searchByDate"
                  v-on:change="creationDate"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Last Year
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="searchByDate"
                  id="flexRadioDefault1"
                  v-b-modal.modal-2
                />
                <label
                  class="form-check-label"
                  for="flexRadioDefault1"
                  v-b-modal.modal-2
                >
                  Custom
                </label>
              </div>
            </div> -->
          </div>
        </div>

        <div class="dropup">
          <button class="dropbtn">
            <a href="#"
              ><img
                src="~@/assets/story/images/noun_gender_3677814.png"
                alt="Logo"
                class="logo-img"
              />Gender</a
            >
          </button>
          <div class="dropup-content">
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="glyphicon glyphicon-user"></i
              ></span>
              <input
                id="email"
                type="text"
                class="form-control"
                name="search"
                placeholder="Search"
              />
            </div>

            <div class="radioGroup">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  All
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Non-binary
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Female
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Male
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Custom
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="dropup">
          <button class="dropbtn">
            <a href="#"
              ><img
                src="~@/assets/story/images/noun_color_1250538.svg"
                alt="Logo"
                class="logo-img"
              />Color</a
            >
          </button>
          <div class="dropup-content">
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="glyphicon glyphicon-user"></i
              ></span>
              <input
                id="email"
                type="text"
                class="form-control"
                name="search"
                placeholder="Search"
              />
            </div>

            <div class="radioGroup">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  All
                </label>
              </div>

              <div class="circles">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>

              <div class="form-check"></div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="color"
                  id="flexRadioDefault1"
                  data-target="#modalColor"
                  data-toggle="modal"
                />
                <label
                  class="form-check-label"
                  for="flexRadioDefault1"
                  data-target="#modalColor"
                  data-toggle="modal"
                >
                  Custom
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="dropup">
          <button class="dropbtn">
            <a href="#"
              ><img
                src="~@/assets/story/images/noun_Project_3323792.png"
                alt="Logo"
                class="logo-img"
              />
              Story</a
            >
          </button>
          <div class="dropup-content">
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="glyphicon glyphicon-user"></i
              ></span>
              <input
                id="email"
                type="text"
                class="form-control"
                name="search"
                placeholder="Search"
              />
            </div>

            <div class="radioGroup">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  All
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Long
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Medium
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Short
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Custom
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="dropup">
          <button class="dropbtn">
            <a class="active" href="#"
              ><img
                src="~@/assets/story/images/noun_Clapperboard_573150.svg"
                alt="Logo"
                class="logo-img"
              />Scene</a
            >
          </button>
          <div class="dropup-content">
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="glyphicon glyphicon-user"></i
              ></span>
              <input
                id="email"
                type="text"
                class="form-control"
                name="search"
                placeholder="Search"
              />
            </div>

            <div class="radioGroup">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  All
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Logic Scenes
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  3D Scenes
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  2D Scenes
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="scenes"
                  id="flexRadioDefault1"
                  data-target="#modalScenes"
                  data-toggle="modal"
                />
                <label
                  class="form-check-label"
                  for="flexRadioDefault1"
                  data-target="#modalScenes"
                  data-toggle="modal"
                >
                  Custom
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="dropup">
          <button class="dropbtn">
            <a href="#"
              ><img
                src="~@/assets/story/images/Group-33.png"
                alt="Logo"
                class="logo-img"
              />
              Experience</a
            >
          </button>
          <div class="dropup-content">
            <!--            <div class="input-group">-->
            <!--              <span class="input-group-addon"-->
            <!--              ><i class="glyphicon glyphicon-user"></i-->
            <!--              ></span>-->
            <!--              <input-->
            <!--                id="experience"-->
            <!--                type="text"-->
            <!--                class="form-control"-->
            <!--                name="search"-->
            <!--                placeholder="Search"-->
            <!--                v-model="experienceSearch"-->
            <!--                @keyup="searchExperience"-->
            <!--              />-->
            <!--            </div>-->

            <div class="radioGroup">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                  v-model="allExperienceSelected"
                  @change="searchExperienceFilter('all')"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  All
                </label>
              </div>

              <template v-for="experience in experienceFilter">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="experience.checked"
                    @change="searchExperienceFilter(experience)"
                    id="flexCheckDefault"
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    {{ experience.name }}
                  </label>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="dropup">
          <button class="dropbtn">
            <a href="#" class="dropbtn"
              ><img
                src="~@/assets/story/images/605e20e49af6eb2e6dd0fa46_noun_component_2651586.png"
                alt="Logo"
                class="logo-img"
              />
              Assets</a
            >
          </button>
          <div class="dropup-content">
            <div class="input-group">
              <span class="input-group-addon"
                ><i class="glyphicon glyphicon-user"></i
              ></span>
              <input
                id="email"
                type="text"
                class="form-control"
                name="search"
                placeholder="Search"
              />
            </div>

            <div class="radioGroup">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  All
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Character
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  3D/2.5D Environment
                </label>
              </div>

              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  3D Model
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Sound
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Animation
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Voice
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  2D Media
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Visual Effect
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Custom
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Start Modal Popup for filter custom-->
    <div class="customFilterModalPopups">
      <!-- Custom Color modal START -->
      <div class="modal fade" id="modalColor" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <h4>Custom Color</h4>
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div class="modal-body">
              <label>Name: </label>
              <input v-model="text" placeholder="Type name here" />
              <div style="float: left">
                <label style="float: left">Color: </label>
              </div>

              <div style="float: left">
                <input
                  style="width: 50px; height: 20px"
                  type="color"
                  v-model="text"
                  id="head"
                  name="head"
                  value="#e66465"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Custom Color modal END -->
      <!-- Custom Scenes modal START -->
      <div class="modal fade" id="modalScenes" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Custom Scenes</h4>
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div class="modal-body">
              <label>From: </label>
              <input v-model="text" placeholder="Min Scenes" />

              <label>To: </label>

              <input v-model="text" placeholder="Max Scenes" />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Custom Scenes modal END -->
    </div>
    <!-- End Modal Popup for filter custom-->
  </div>
</template>

<script>
import { db, assetAudioStorageRef } from "../../firebaseDB";

export default {
  name: "filters1",
  components: {},
  data: () => ({
    searchAuthorName: null,
    selectAllAuthors: false,
    searchByDate: null,
    searchByDateChk: null,
    allOrganizationSelect: false,
    searchOrganizationsName: "",
    fromDate: null,
    toDate: null,
    text: null,
    value: null,
    dialogCustomOrganization: false,
    dialogColor: false,
    authors: [],
    finalAuthors: [],
    creationDates: [
      { name: "Any" },
      { name: "Last 30 Days" },
      { name: "Last 3 Months" },
    ],
    experienceFilter: [
      {
        name: "AR",
        checked: false,
      },
      {
        name: "VR",
        checked: false,
      },
      {
        name: "Screen",
        checked: false,
      },
    ],
    allExperienceSelected: false,
    // experienceSearch: '',
    isInGridView: true,
    finalCreationDates: [],
    searchDateName: null,
    checkboxChecked: false,
    props: ["search"],
    showModal: false,
    objectItems: {
      key1: "item1",
      key2: "item2",
      key3: "item3",
    },
    organizationList: [],
  }),
  methods: {
    searchAuthors: function () {
      this.finalAuthors = [];
      if (this.searchAuthorName.length === 0) {
        for (const authorsKey in this.authors) {
          this.finalAuthors.push({
            name:
              this.authors[authorsKey].charAt(0).toUpperCase() +
              this.authors[authorsKey].slice(1),
            checked: false,
          });
        }
        return;
      }
      this.authors.filter((value) => {
        if (value.startsWith(this.searchAuthorName.toLowerCase())) {
          this.finalAuthors.push({
            name: value.charAt(0).toUpperCase() + value.slice(1),
            checked: false,
          });
        }
      });
    },
    searchDates: function () {
      this.finalCreationDates = [];
      if (this.searchDateName.length === 0) {
        this.finalCreationDates = this.creationDates;
        return;
      }
      this.creationDates.filter((date) => {
        if (
          date.name.toUpperCase().startsWith(this.searchDateName.toUpperCase())
        ) {
          this.finalCreationDates.push({
            name: date.name,
          });
        }
      });
    },
    creationDate: function () {
      this.searchByDate =
        this.searchByDateChk !== true
          ? this.searchByDate
          : this.$refs.precheck.value;
      this.$emit("creationDateFilter", this.searchByDate);
    },
    creationDateByCustom: function () {
      if (this.toDate != null && this.fromDate != null) {
        this.$emit("creationDateFilterByCustom", {
          fromDate: this.fromDate,
          toDate: this.toDate,
        });
      } else {
        this.toDate = this.toDate ? this.toDate : this.fromDate;
        this.fromDate = this.fromDate ? this.fromDate : this.toDate;
        return false;
      }
      this.$emit("creationDateFilter", this.searchByDate);
    },
    setSortOrder: function (val) {
      this.$emit("sortOrderFilter", val);
    },
    setViewAs: function (val) {
      this.isInGridView = val;
      this.$emit("viewAs", val);
    },
    update: function (user) {
      if (user.name === "Custom") {
        this.showModal = true;
      } else {
        for (const finalAuthorsKey in this.finalAuthors) {
          if (user === "All") {
            this.finalAuthors[finalAuthorsKey].checked = this.selectAllAuthors;
          }
        }
      }
      this.$emit("filterDetails", this.finalAuthors);
    },
    toggleMenu: function () {
      const data = this.$store.state.stories;
      this.finalCreationDates = this.creationDates;
      let orgList = [];
      this.organizationList = [];
      for (const property in data) {
        if (
          data[property].hasOwnProperty("author") &&
          !data[property].author.includes("@") &&
          !this.authors.includes(data[property].author.toLocaleLowerCase())
        ) {
          this.authors.push(data[property].author.toLocaleLowerCase());
          this.finalAuthors.push({
            name: data[property].author,
            checked: false,
          });
        }
        if (
          data[property].hasOwnProperty("organization") &&
          data[property].organization
        ) {
          orgList.push({
            name:
              data[property].organization.charAt(0).toUpperCase() +
              data[property].organization.slice(1),
            checked: false,
          });
        }
        this.organizationList = orgList;
      }
      var x = document.getElementById("navbar");
      if (x.style.display === "none" || x.style.display === "") {
        x.style.display = "block";
      } else {
        x.style.display = "none";
      }
    },
    organizationFilter(org) {
      if (org === "All") {
        this.organizationList = this.organizationList.map((value) => {
          value.checked = this.allOrganizationSelect;
          return value;
        });
      }
      this.$emit("organizationSearch", this.organizationList);
    },
    searchOrganizations() {
      this.organizationList = [];
      if (!this.searchOrganizationsName.length) {
        this.$store.state.stories.map((value) => {
          if (value.hasOwnProperty("organization") && value.organization) {
            this.organizationList.push({
              name:
                value.organization.charAt(0).toUpperCase() +
                value.organization.slice(1),
              checked: false,
            });
          }
        });
        return;
      }
      let list = this.$store.state.stories;
      for (const listKey in list) {
        if (
          list[listKey].hasOwnProperty("organization") &&
          list[listKey].organization &&
          list[listKey].organization
            .toLowerCase()
            .startsWith(this.searchOrganizationsName.toLowerCase())
        ) {
          this.organizationList.push({
            name:
              list[listKey].organization.charAt(0).toUpperCase() +
              list[listKey].organization.slice(1),
            checked: false,
          });
        }
      }
    },
    searchExperienceFilter(data) {
      console.log("test experience filter: " + data);
      if (data === "all") {
        this.experienceFilter = this.experienceFilter.map((value) => {
          value.checked = this.allExperienceSelected;
          return value;
        });
      }
      this.$emit("searchExperienceFilter", this.experienceFilter);
    },
    openDialogColor() {
      this.dialogColor = true;
    },
    // searchExperience () {
    //   console.log(this.experienceSearch)
    // }
  },
};
</script>

<style scoped>
body {
  margin: 0;
}

.btn:hover {
  background-color: none;
}

.btn.active {
  background-color: #666;
  color: white;
}

#modal-1 label {
  float: left;
  padding: 0px 2px;
  width: 100px;
}

#modal-1 input {
  float: left;
  padding: 0px 50px;
  width: 300px;
  background-color: #e0e0e0;
}

#modal-5 label {
  float: left;
  padding: 0px 2px;
  width: 200px;
}

#modal-5 select {
  float: left;
  padding: 0px 50px;
  width: 200px;
  border: 1px solid #c6c6c6;
}

#modal-4 label {
  float: left;
  padding: 0px 2px;
}

#modal-4 input {
  width: 200px;
  float: left;
  height: 22px;
  background-color: #e0e0e0;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.circles {
  height: 60px;
  width: 100px;
  margin: 0px 20px 0px 20px;
}

.circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid;
  background-color: #f8904a;
  float: left;
  margin: 2px 4px 6px 6px;
}

.assets {
  width: 100%;
  float: left;
  display: none;
}

#assets {
  display: none;
}

.assets span {
  margin: 14px 0px 5px 10px;
  float: left;
  color: #000;
}

.radioGroup {
  margin-top: 10px;
}

.dropbtn {
  border: none;
}

.dropup {
  position: relative;
  display: inline-block;
}

.dropup-content {
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 160px;
  top: 25px;
  z-index: 1;
  left: 0px;
  height: 250px;
  overflow-y: scroll;
  border: 1px solid #cecece;
  padding: 10px 10px;
  font-family: Exo, sans-serif;
  font-size: 12px;
  color: #000;
}

.dropup-content input[type="text"] {
  border: 1px none #000;
  background-color: #e0e0e0;
  font-size: 9px;
}

.dropup-content a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropup-content a:hover {
  background-color: #fff;
}

.dropup:hover .dropup-content {
  display: block;
}

.dropup:hover .dropbtn {
  background-color: none;
}

.icon-bar {
  width: 100%;
  overflow: auto;
}

.right-top {
  float: right;
  margin-top: -30px;
}

.right-top a {
  margin: 0px 2px 2px 2px;
  text-align: center;
  font-size: 15px;
  font-weight: none;
  color: #000;
  text-decoration: none;
}

.btn-group {
  font-size: 13px !important;
}

.icon-bar img {
  margin: 0px 2px 2px 2px;
  width: 20px;
}

.icon-bar a {
  float: left;
  margin-right: 10px;
  text-align: center;
  font-size: 20px;
  font-weight: none;
  color: #000;
}

.icon-bar a:hover {
  background-color: none;
}

.active {
  background-color: none;
}

.tabs {
  margin: 2px auto;
}

.navbar {
  display: none;
  font-family: Exo, sans-serif;
  color: #747474;
}

.navbar span {
  margin: 14px 0px 5px 10px;
  float: left;
}

.navbar img {
  margin: 0px 2px 5px 0px;
}

.navbar button {
  color: #000;
  text-decoration: none;
  font-size: 13px;
  padding: 2px 25px;
  font-family: Exo, sans-serif;
  color: #747474;
}

.navbar a {
  text-align: left;
  color: #000;
  text-decoration: none;
  font-size: 13px;
}

.radioGroup {
  text-align: left !important;
}

.navbar a:hover {
  background-color: none;
}

.active {
  background-color: none;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

.dropdown-item i {
  opacity: 1;
  font-size: 60%;
  color: white;
}

.filter-btn {
    background-color: #333a43;
    border-radius: 15px 15px 0px 0px;
    width: 140px !important; 
    color: white;
}

.dropdown-menu {
    width: 100px !important;
    background-color: #f5f7f9;
    padding: 0px 10px 15px 10px;
    background-image: linear-gradient( #edeff3, #dee8f1);
}
.dropdown-item {
    background-color: transparent;
    color: #333a43;
    border-bottom: 1px solid #b6cad8;
    padding-left: 0%;
    padding-right: 0%;
    margin-bottom: 5px;
}
.dropdown-item:hover {
    background-color: transparent;
    color: #333a43;
}
.up-down-btn {
    position: relative;
    top: 17px;
    background-color: #4d66b1;
    border-radius: 15%;
    padding: 1px;
}
.fa-arrow-down:hover, .fa-arrow-up:hover {
    color: #b6cad8;
}

</style>




// WEBPACK FOOTER //
// src/components/filters/filters2.vue